// import $ from 'jquery';

$(document).ready(() => {
  const $elements = $('.accordion');
  $elements.each((index, el) => {
    const $title = $(el).find('.accordion-title');
    $title.append('<span class="accordion-toggle" role="button" tabindex="0" aria-label="toggle content"></span>');
    const $toggle = $(el).find('.accordion-title');
    const $content = $(el).find('.accordion-content');
    $content.slideUp();
    $toggle.bind('click keypress', (event) => {
      if ($(event.target).hasClass('link') === true) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      const key = event.which;
      if (event.type === 'click' || (event.type === 'keypress' && (key === 13 || key === 32))) {
        $(el).toggleClass('active');
        $content.slideToggle();
      }
    });
  });

  $('.mobile-nav-close').click(function() {
    const accordionActive = $('.accordion').hasClass('active');
    if (accordionActive) {
      $('.accordion.active').find('.accordion-title').trigger( "click" );
    }
  });
});
